/**
 * Task API wrapper for DataTable server-side operations
 * Wraps the realtime controller to work with DataTable's apiMethod pattern
 */
import getTaskController from './realtime-task-controller';

const controller = getTaskController();

/**
 * Get tasks with pagination, search, and filtering
 * Compatible with DataTable apiMethod signature
 * @param {Object} options - Query options from DataTable
 * @param {number} options.page - Current page number
 * @param {number} options.itemsPerPage - Items per page
 * @param {string} options.search - Search term
 * @param {Object} options.match - Additional match filters
 * @param {Object} options.sort - Sort configuration
 * @returns {Promise<{data: Array, total: number}>}
 */
export const GetTasks = async (options = {}) => {
    try {
        const requestOptions = {
            suspended: true,
            page: options.page || 1,
            limit: options.itemsPerPage || 20,
            search: options.search || '',
            match: options.match || {}
        };

        const response = await controller.getTaskList(requestOptions);

        // If backend returns array directly, wrap it
        if (Array.isArray(response)) {
            return {
                data: response,
                total: response.length
            };
        }

        // If backend returns {tasks, total}
        return {
            data: response.tasks || response.data || [],
            total: response.total || response.count || 0
        };
    } catch (error) {
        console.error('[GetTasks] Error:', error);
        return {
            data: [],
            total: 0
        };
    }
};
